import {YouTubeVideoType} from "../../definitions/types";

import {YouTubeThumbnailCollectionModel} from "./youTubeThumbnailCollectionModel";

export class YouTubeVideoModel {
    private readonly _id: string;
    private readonly _title: string;
    private readonly _description: string;
    private readonly _uploadStatus: string;
    private readonly _privacyStatus: string;
    private readonly _thumbnailCollection: YouTubeThumbnailCollectionModel;

    constructor({id, title, description, uploadStatus, privacyStatus, thumbnailCollection}: YouTubeVideoType) {
        this._id = id;
        this._title = title;
        this._description = description;
        this._uploadStatus = uploadStatus;
        this._privacyStatus = privacyStatus;
        this._thumbnailCollection = new YouTubeThumbnailCollectionModel(thumbnailCollection);
    }

    /**
     * @property id
     * @description The ID that YouTube uses to uniquely identify the video.
     * @returns {string}
     */
    public get id(): string {
        return this._id;
    }

    /**
     * @property title
     * @description The video's title.
     * @returns {string}
     */
    public get title(): string {
        return this._title;
    }

    /**
     * @property description
     * @description The video's description.
     * @returns {string}
     */
    public get description(): string {
        return this._description;
    }

    /**
     * @property uploadStatus
     * @description The status of the uploaded video.
     * @returns {string}
     */
    public get uploadStatus(): string {
        return this._uploadStatus;
    }

    /**
     * @property privacyStatus
     * @description The video's privacy status.
     * @returns {string}
     */
    public get privacyStatus(): string {
        return this._privacyStatus;
    }

    /**
     * @property thumbnailCollection
     * @description The video's thumbnail images.
     * @returns {YouTubeThumbnailCollectionModel}
     */
    public get thumbnailCollection(): YouTubeThumbnailCollectionModel {
        return this._thumbnailCollection;
    }
}